import React from 'react'
import { Button, ButtonStyle } from '../../components/simple/button'

/**
 * This component is shown when the user is on a mobile device and tries to access a page that does not work on mobile.
 * It shows a message and two buttons: one to go home and one to continue anyways.
 */
export const NoMobileOverlay: React.FC = () => {
  const [shown, setShown] = React.useState(true)
  return (
    shown && (
      <div className="fixed inset-0 z-[99999] flex flex-col items-center justify-center gap-2 bg-white sm:hidden">
        <b>This page does not work on mobile</b>
        <div className="flex gap-2">
          <Button link="/">Go Home</Button>
          <Button onClick={() => setShown(false)} buttonStyle={ButtonStyle.blue}>
            Continue Anyways
          </Button>
        </div>
      </div>
    )
  )
}
